import "./index.scss";

import PropTypes from "prop-types";

/**
 * Modal popup component for confirming data deletion.
 * Displays a confirmation dialog asking the user if they want to delete their saved data.
 * Provides Yes/No buttons for user selection.
 *
 * @param {Object} props - Component props
 * @param {Function} props.clearData - Function to execute when user confirms data deletion
 * @param {Function} props.setShowClearData - Function to hide the popup modal
 * @returns {JSX.Element} Modal popup with data deletion confirmation
 */
const ClearDataPopup = ({ clearData, setShowClearData }) => {
  return (
    <div className="cleardatapopup_fullscreen" role="alertdialog" aria-modal="true" aria-label="Delete saved data confirmation">
      <div className="cleardatapopup_modal">
        <div className="cleardatapopup_modalcontentscontainer">
          <h1>Do you want to delete your saved data?</h1>
          <div className="cleardatapopup_buttoncontainer">
            <div
              className="cleardatapopup_buttonno"
              onClick={() => setShowClearData(false)}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setShowClearData(false); } }}
              role="button" tabIndex={0} aria-label="No, keep my data"
            >
              <p className="cleardatapopup_buttontext">No</p>
            </div>
            <div
              className="cleardatapopup_buttonyes"
              onClick={() => clearData()}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); clearData(); } }}
              role="button" tabIndex={0} aria-label="Yes, delete my data"
            >
              <p className="cleardatapopup_buttontext">Yes</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClearDataPopup;

ClearDataPopup.propTypes = {
  clearData: PropTypes.func,
  setShowClearData: PropTypes.func,
};
